<template>
  <div class="shadow-lg py-5 px-7">
    <h4 class="text-xl font-bold mb-4">Primes managers</h4>

    <div class="mb-1">
      <label for="manager_percentage_value" class="block text-sm font-medium text-gray-700 mb-2">Pourcentage</label>
      <div class="flex items-center gap-3">
        <div class="flex-1">
          <FormField
            id="manager_percentage_value"
            name="manager_percentage_value"
            trailing-add-ons="%"
            v-model="managerPercentageValue"
          />
        </div>
        <GenericButton @click="submitEditManagerPercentage">Enregistrer</GenericButton>
      </div>
    </div>

    <div class="relative my-2">
      <div class="absolute inset-0 flex items-center">
        <div class="w-full border-t border-gray-200"></div>
      </div>
      <div class="relative flex justify-center">
        <span class="bg-gray-50 px-3 text-xs font-semibold uppercase tracking-widest text-gray-900">ou</span>
      </div>
    </div>

    <div class="flex justify-center">
      <SecondaryButton @click="configManagerFixedPriceModalOpen = true">Configurer montant fixe</SecondaryButton>
    </div>

    <Modal size="big" :open="configManagerFixedPriceModalOpen" @close="configManagerFixedPriceModalOpen = false">
      <h4 class="text-xl font-semibold">Rétribution en montant fixe</h4>
      <p>Indiquer le montant de la rétribution par offre et par durée.</p>

      <RetributionTable
        :retributions="retributionConfigurations"
        editable
        @edit-manager-retribution="editRetributionConfiguration"
        :hideManagerRetribution="false"
        :hideSellerRetribution="true"
      />
      <div class="mt-4 flex justify-center">
        <GenericButton @click="submitEditManagerFixedPrice">Valider la rétribution</GenericButton>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { Modal, FormField, GenericButton, SecondaryButton } from "@estaly/ui";
import RetributionTable from "@/components/retribution/RetributionTable.vue";
import RetributionConfigurationsService from "@/api/services/retributionConfigurations";

export default {
  name: "ManagerRetributionConfiguration",

  components: {
    FormField,
    Modal,
    GenericButton,
    SecondaryButton,
    RetributionTable,
  },

  data() {
    return {
      configManagerFixedPriceModalOpen: false,
      managerPercentageValue: null,
      retributionConfigurationsManagerFixedPriceChanges: {},
    };
  },

  computed: {
    ...mapState("store", { currentStore: "currentStore" }),
    ...mapState("retributionConfigurations", ["retributionConfigurations"]),
  },

  methods: {
    ...mapActions("store", ["fetch"]),
    ...mapActions("retributionConfigurations", ["fetchRetributionConfigurations"]),
    ...mapActions("notifications", ["notify", "clearAll"]),

    async submitEditManagerPercentage() {
      if (this.managerPercentageValue === null || this.managerPercentageValue === undefined)
        return document.getElementById("manager_percentage_value").focus();

      const response = await RetributionConfigurationsService.updatePercentage(this.currentStore.id, {
        managerValue: this.managerPercentageValue / 100,
        managerPercentage: true,
      });
      if (!response?.success) return;

      await Promise.all([
        this.fetch({ id: this.currentStore.id }),
        this.fetchRetributionConfigurations({ perPage: 1000 }),
      ]);
      await this.notify({
        category: "simple",
        type: "success",
        title: "Mise à jour effectuée",
      });
    },

    editRetributionConfiguration(retributionConfigurationId, value) {
      this.retributionConfigurationsManagerFixedPriceChanges[retributionConfigurationId] = value;
    },

    async submitEditManagerFixedPrice() {
      this.clearAll();
      const errors = [];

      await Promise.all(
        Object.entries(this.retributionConfigurationsManagerFixedPriceChanges).map(
          async ([retributionConfigurationId, value]) => {
            const response = await RetributionConfigurationsService.updateFixedPrice(
              this.currentStore.id,
              retributionConfigurationId,
              {
                managerValue: value,
                managerPercentage: false,
              },
            );
            if (!response?.success) errors.push(retributionConfigurationId);
            else {
              this.lowlightError(retributionConfigurationId);
              delete this.retributionConfigurationsManagerFixedPriceChanges[retributionConfigurationId];
            }
          },
        ),
      );

      await this.fetchRetributionConfigurations({ perPage: 1000 });

      if (errors.length === 0) {
        await this.notify({
          category: "simple",
          type: "success",
          title: "Mise à jour effectuée",
        });
        this.configManagerFixedPriceModalOpen = false;
      } else {
        errors.forEach((retributionConfigurationId) => {
          this.highlightError(retributionConfigurationId);
        });
      }
    },

    highlightError(retributionConfigurationId) {
      document
        .getElementById(`manager-retribution-${retributionConfigurationId}`)
        .classList.add("border-2", "border-red-500");
    },

    lowlightError(retributionConfigurationId) {
      document
        .getElementById(`manager-retribution-${retributionConfigurationId}`)
        .classList.remove("border-2", "border-red-500");
    },
  },

  watch: {
    currentStore: {
      immediate: true,
      handler(store) {
        this.managerPercentageValue = store?.managerIncentivePercentage
          ? Math.round(store.managerIncentivePercentage * 100)
          : null;
        this.retributionConfigurationsManagerFixedPriceChanges = {};
      },
    },
  },
};
</script>
